import React from "react";
import {Button, ModalBody, ModalFooter, ModalHeader, ModalTitle} from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import {useTranslation} from "react-i18next";

export default function HistoryDeleteLastMove(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'deleteLastMove' });
    return (
        <Modal
            show={true}
            onHide={props.onClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <ModalHeader closeButton>
                {props.errorMessage !== "" ? <ModalBody>{props.errorMessage}</ModalBody> : <ModalTitle>{t('deleteLastMoveQ')}</ModalTitle>}
            </ModalHeader>
            <ModalFooter>
                <Button variant="primary" style={{backgroundColor: "#59619B"}}
                        onClick={props.onClose}>{t('cancel')}</Button>
                {props.errorMessage === "" && <Button variant="primary" style={{backgroundColor: "red"}} onClick={props.onConfirm}>{t('confirmDelete')}</Button>}
            </ModalFooter>
        </Modal>
    )

}
